import { render } from "./MutualSettlements.vue?vue&type=template&id=8cefae62"
import script from "./MutualSettlements.vue?vue&type=script&lang=js"
export * from "./MutualSettlements.vue?vue&type=script&lang=js"

import exportComponent from "/Users/tin/Documents/asket/stone-xxi.ru-v2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__